exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#dify-chatbot-bubble-button{background-color:#1c64f2!important}#dify-chatbot-bubble-window{position:fixed!important;width:35rem!important;height:38rem!important}", ""]);

// exports
